import { Notification } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { LinkButton } from '@uag/welcome-shared/src/components/LinkButton';
import { useTranslation } from 'react-i18next';

import { AiPlausibilityDrawer } from './AiPlausibilityDrawer';
import { riskLevelConfig, toKnownRiskLevel } from './riskLevel';

import type { AiPlausibilityResultModel } from '@uag/welcome-shared/src/api/models';

type Props = {
    result: AiPlausibilityResultModel;
    canViewDetails: boolean;
};

export const AiPlausibilityHint = ({ result, canViewDetails }: Props) => {
    const { t } = useTranslation();
    const [drawerOpened, { open: openDrawer, close: closeDrawer }] = useDisclosure(false);
    const riskLevel = toKnownRiskLevel(result.overall.riskLevel);
    const config = riskLevel && riskLevelConfig[riskLevel];

    return (
        <>
            <Notification
                title={t('aiPlausibilityVerificationStatus')}
                variant={config?.notificationVariant}
                withCloseButton={false}
            >
                {config ? t(config.hintKey) : t('aiPlausibilityHintUnknownRisk')}
                {canViewDetails && (
                    <LinkButton className="ml-xs" label={t('aiPlausibilityViewDetails')} onClick={openDrawer} />
                )}
            </Notification>
            {canViewDetails && <AiPlausibilityDrawer opened={drawerOpened} result={result} onClose={closeDrawer} />}
        </>
    );
};
